import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Progress, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { ChevronLeft, X } from 'react-feather';

import mapVendor from '../../../../../../../assets/images/map-vendor.svg';
import { MdOutlineCloudUpload } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { DOWNLOAD_PRICE_FILE, DOWNLOAD_PRICE_FILE_EMPTY, UPLOAD_PRICE_FILE, UPLOAD_PRICE_FILE_EMPTY } from '../../../../../../../store/actions';
import { FaFileExcel } from 'react-icons/fa';
import TypeCard from '../Comman/TypeCard';

const UploadVendorPricing = ({ state, setState, setFormCount }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [vendorPricingRows, setVendorPricingRows] = useState([]);
  const [progress, setProgress] = useState(0);

  const { downloadPriceType, uploadPriceType, uploadPriceTypeLoading } = useSelector((state: any) => ({
    downloadPriceType: state.DownloadPriceType.data,

    uploadPriceType: state.UploadPriceType.data,
    uploadPriceTypeLoading: state.UploadPriceType.loading,
  }));

  // Simulate progress bar when loading
  useEffect(() => {
    if (uploadPriceTypeLoading) {
      let p = 0;
      const interval = setInterval(() => {
        p += 5;
        if (p >= 100) {
          clearInterval(interval);
          dispatch({ type: DOWNLOAD_PRICE_FILE_EMPTY });
        } else {
          setProgress(p);
        }
      }, 300);

      return () => clearInterval(interval);
    } else {
      setProgress(0);
    }
  }, [uploadPriceTypeLoading, dispatch]);

  useEffect(() => {
    if (uploadPriceType !== null) {
      handleUploadDataUpdate(uploadPriceType?.results);
    }
  }, [uploadPriceType]);

  const generateFileName = () => {
    const clientName = state?.client?.name;
    const today = new Date();

    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    return `AT_Vendor_Price_${clientName}_${formattedDate}${state?.version ? `_v${state?.version}` : ''}.xlsx`;
  };

  useEffect(() => {
    if (downloadPriceType) {
      const blob = new Blob([downloadPriceType], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = generateFileName();
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch({
        type: DOWNLOAD_PRICE_FILE_EMPTY,
      });
    }
  }, [downloadPriceType]);

  const makeRows = (airports, vendors) => {
    const result = [];
    airports?.forEach(airport => {
      airport.zones?.forEach(zone => {
        vendors?.forEach(vendor => {
          const hasZone = vendor.zones?.some(vz => vz.id === zone.id && vz.airport.id === airport.id);

          if (hasZone) {
            if (vendor.carTypes && vendor.carTypes.length > 0) {
              vendor.carTypes.forEach(carType => {
                ['Pickup', 'Drop'].forEach(serviceType => {
                  result.push({
                    id: `${airport?.id}:${zone?.id}:${vendor?.id}:${carType?.id}:${serviceType}:${vendor.currency}`,
                    airport: {
                      id: airport?.id,
                      name: airport?.name,
                    },
                    zone: { id: zone?.id, name: zone?.name },
                    vendor: {
                      id: vendor?.id,
                      firstName: vendor?.firstName,
                      lastName: vendor?.lastName,
                      name: `${vendor?.firstName?.trim() || ''} ${vendor?.lastName?.trim() || ''}`.trim(),
                    },
                    carType: {
                      id: carType?.id,
                      name: carType?.name,
                    },
                    serviceType,
                    currency: vendor.currency || airport.currency || 'AED',
                  });
                });
              });
            } else {
              result.push({
                airport: {
                  id: zone?.id,
                  name: airport?.name,
                  zone: airport?.zones?.map(airportZone => {
                    return {
                      id: airportZone?.id,
                      name: airportZone?.name,
                      airport: airportZone?.airport,
                    };
                  }),
                },
                zone: { id: zone?.id, name: zone?.name, airport: zone?.airport },
                vendor: {
                  id: vendor?.id,
                  firstName: vendor?.firstName,
                  lastName: vendor?.lastName,
                  email: vendor?.email,
                  carTypes: vendor?.carTypes ?? [],
                  currency: vendor?.currency,
                  name: `${vendor?.firstName?.trim() || ''} ${vendor?.lastName?.trim() || ''}`.trim(),
                },
                serviceType: 'Pickup',
                currency: vendor.currency || airport.currency || 'AED',
              });
            }
          }
        });
      });
    });

    return result;
  };

  useEffect(() => {
    if (state?.vendorPricing?.pricingDetails?.length > 0) {
      const newVendorRows = makeRows(state?.vendorPricing?.airports, state?.vendorPricing?.vendors);
      const existingVendorRowsMap = new Map(state?.vendorPricing?.pricingDetails?.map(item => [item.id, item]));

      const combineAlltheRows = newVendorRows.map(item => {
        const commanRows = existingVendorRowsMap.get(item.id);
        const merged = commanRows ? { ...item, ...commanRows } : item;

        return {
          ...merged,
          vendor: {
            ...merged.vendor,
            name: `${merged.vendor?.firstName?.trim() || ''} ${merged.vendor?.lastName?.trim() || ''}`.trim(),
          },
        };
      });

      setVendorPricingRows(combineAlltheRows);
    } else {
      const getRows = makeRows(state?.vendorPricing?.airports, state?.vendorPricing?.vendors);
      setVendorPricingRows(getRows ?? []);
    }
  }, []);

  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        pricingDetails: vendorPricingRows,
      },
    }));
    setFormCount(prev => prev + 1);
  };

  const handleUploadDataUpdate = updatedRows => {
    const pricingDetailsSummary = vendorPricingRows?.map(row => {
      const match = updatedRows?.find(item => item?.id === row?.id);
      if (match) {
        const basePriceChanged = row.basePrice !== match.basePrice;
        const parkingFeeChanged = row.parkingFee !== match.parkingFee;

        if (basePriceChanged || parkingFeeChanged) {
          return {
            ...row,
            basePrice: match.basePrice,
            parkingFee: match.parkingFee,
            ...(row.hasOwnProperty('tag') && row?.tag === 'default' ? { tag: 'updated' } : {}), // only add if tag exists
          };
        } else {
          return {
            ...row,
            basePrice: match.basePrice,
            parkingFee: match.parkingFee,
          };
        }
      }

      return row;
    });

    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        pricingDetails: pricingDetailsSummary,
      },
    }));

    setFormCount(prev => prev + 1);

    dispatch({
      type: UPLOAD_PRICE_FILE_EMPTY,
    });
  };

  const fileHandler = async e => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    dispatch({
      type: UPLOAD_PRICE_FILE,
      payload: {
        data: formData,
        priceType: 'vendor-price-file',
      },
    });

    e.target.value = null;
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <BreadcrumbTrail
            title={`Airport Configuration Setup`}
            navigationby={breadcrumNavigationHandler}
            navigation={['Management', 'Program', 'Onboarding', 'Upload Vendor Pricing']}
          />
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Vendor Pricing Upload</h5>
            <TypeCard typeName={'Client'} name={state?.client?.name} />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="7">
                <h4 className="mb-4 text-primary fw-medium">Upload File</h4>

                <div
                  className="upload-box mb-2 position-relative"
                  onClick={() => document.getElementById('fileInput').click()}
                  style={{ cursor: 'pointer' }}
                >
                  <input type="file" id="fileInput" accept=".xlsx" style={{ display: 'none' }} onChange={fileHandler} />
                  <MdOutlineCloudUpload size={40} className="mb-2 text-primary" />
                  <p className="mb-1">
                    Drag your file(s) or <span className="browse-text">browse</span>
                  </p>
                  <small className="text-muted">Supported format: .xlsx</small>
                </div>

                <p
                  className="text-primary fw-semibold text-end text-decoration-underline cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: DOWNLOAD_PRICE_FILE,
                      payload: {
                        priceType: 'vendor-price-file',
                        data: vendorPricingRows,
                      },
                    });
                  }}
                >
                  Click here to download your configured file and add pricing.
                </p>

                <div className="file-rules-card">
                  <p className="px-3 pt-3 fw-semibold">File Rules</p>
                  <div className="px-3 pb-2">
                    <ul className="list-unstyled mb-0 gap-1">
                      {['File type: .xlsx only', 'Maximum file size: 5MB', 'Maximum rows: 10,000', 'File Version - V2.0'].map((rule, idx) => (
                        <li key={idx} className="mb-2 d-flex align-items-center gap-2">
                          <i className="ri-check-fill" style={{ color: 'rgba(88, 109, 177, 1)' }}></i> <p className="m-0">{rule}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {uploadPriceTypeLoading && (
                  <FileDownloadCard
                    filename="demo.xls"
                    size="500kb"
                    progress={progress}
                    onCancel={() => dispatch({ type: DOWNLOAD_PRICE_FILE_EMPTY })}
                  />
                )}
              </Col>

              <Col md="5">
                <div className="position-relative border rounded p-3">
                  <h5>Vendor Pricing</h5>
                  <p className="text-muted small">Upload pricing here to map them to Clients</p>
                  <div className="vendor-mapping-list">
                    {state?.vendorPricing?.vendors?.map((vendor, index) => (
                      <Card
                        key={index}
                        className="mb-3 p-2"
                        style={{
                          border: '1px dashed #D1D1D1',
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex flex-column pt-2 px-2">
                            <div className="d-flex gap-1 align-items-start">
                              <img className="mt-3" src={mapVendor} alt="" />
                              <div className="mt-2">
                                <div className="d-flex gap-2 align-items-center">
                                  <h6 className="m-0 fw-medium fs-14">
                                    {vendor?.name || ''} {vendor?.firstName || ''} {vendor?.lastName || ''}
                                  </h6>
                                  <p
                                    style={{
                                      color: vendor?.tag === 'partially_configured' ? '#F59E0B' : '#0AB39C',
                                      border: vendor?.tag === 'partially_configured' ? '1px solid #F59E0B' : '1px solid #0AB39C',
                                      borderRadius: '20px',
                                      fontSize: '6px',
                                    }}
                                    className="m-0 pt-1 pb-1 px-2 pe-2"
                                  >
                                    {vendor?.tag === 'partially_configured' ? 'Partially Configured' : 'Full Configured'}
                                  </p>
                                </div>
                                <div className="d-flex gap-2 mt-1">
                                  <p className="text-muted small m-0">
                                    {vendor?.tag === 'partially_configured' ? vendor?.region?.value ?? '' : vendor?.region ?? ''}
                                  </p>
                                  <div className="d-flex flex-wrap gap-1">
                                    {vendor?.carTypes?.map((car, idx) => (
                                      <p
                                        key={idx}
                                        style={{
                                          borderRadius: '20px',
                                          padding: '5px 5px',
                                          fontSize: '8px',
                                          border: '1px solid #D0D2DC',
                                          color: '#6F7594',
                                        }}
                                        className="m-0"
                                      >
                                        {car?.name?.split(' ')[0]}
                                      </p>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {vendor?.zones?.map(zone => (
                          <div
                            key={zone?.id}
                            className="d-flex justify-content-between align-items-center p-2 m-1 rounded-2"
                            style={{
                              border: '1px solid rgba(161, 229, 247, 1)',
                              background: 'rgba(236, 250, 253, 1)',
                            }}
                          >
                            <div
                              className="d-flex flex-column"
                              style={{
                                flex: 1,
                                minWidth: 0,
                              }}
                            >
                              <p className="fw-medium m-0 fs-12" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                {zone?.name}
                              </p>
                              <p className="fw-light m-0 fs-12" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                {zone?.airport?.name}
                              </p>
                            </div>
                          </div>
                        ))}
                      </Card>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount(prev => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{ backgroundColor: '#E9EBEC', color: '#404B7C', fontWeight: 500, boxShadow: 'none', border: 'none' }}
          >
            <ChevronLeft size={18} /> Back
          </Button>
          <Button
            className=""
            style={{ background: 'rgba(255, 255, 255, 1)', color: 'rgba(64, 81, 137, 1)', width: '120px' }}
            color="primary"
            onClick={handleSubmit}
          >
            Skip
          </Button>
        </div>
      </Container>
    </div>
  );
};

const FileDownloadCard = ({ filename = 'demo.xls', size = '500kb', progress = 60, onCancel }) => {
  return (
    <Card
      className="p-2 d-flex flex-row align-items-center justify-content-between mt-3"
      style={{ borderRadius: '1rem', border: '1px solid rgba(231, 231, 231, 1)' }}
    >
      <Row className="align-items-center w-100">
        <Col xs="auto">
          <FaFileExcel size={40} color="#217346" />
        </Col>
        <Col className="ms-2">
          <div style={{ fontWeight: 600 }}>{filename}</div>
          <div className="text-muted" style={{ fontSize: '0.9rem' }}>
            {size}
          </div>
          <Progress value={progress} color="primary" className="mt-2" style={{ height: '8px', borderRadius: '10px' }} />
        </Col>
        <Col xs="auto">
          <X size={18} onClick={onCancel} style={{ cursor: 'pointer' }} />
        </Col>
      </Row>
    </Card>
  );
};

export default UploadVendorPricing;
